window.setInterviewSchedule = function(params){
  const candidate_id = params.id
  loadModal({title: "Set Interview Schedule", url: `/recruitment/interview_schedules/new?candidate_id=${candidate_id}`})
}